import React, { useContext } from 'react'
import { IntlContext } from 'App'
import { supportedLocales } from 'i18n'

export default (props) => {
  const { intl: { locale }, dispatch } = useContext(IntlContext)

  return (
    <select className="p-0 m-0" value={locale} onChange={({ target: { value } }) => dispatch({ action: 'SET_LOCALE', payload: value })}>
      { Object.entries(supportedLocales).map(([locale, name]) => (
        <option className="p-0 m-0" key={locale} value={locale}>{ name }</option> 
      )) }
    </select>
  )
}
